<template>
  <div class="div_informacao_contato" >
    <a href="/contribuicao/contato">
      <button class="informacao_contato">
          <i  class="ion-android-chat" style="color: white;"></i>
      </button>
     </a>
  </div>

</template>

<script>

    export default {
        name: 'BotaoContato',
        components: {

        },
        computed: {

        },
        data() {
            return {

            }
        },
        methods: {

        },
        created () {

        },
    }
</script>

<style>
  .boxing{
    box-sizing: content-box;
  }

  .informacao_contato{
    border-radius:50%;
    background-color: rgb(0 0 0 / 60%);
    border:none;
    height:70px;
    width:70px;
    color:white;
    font-size:40px;
    float:right !important;
    cursor: pointer;

    text-decoration: none;
    text-align: center;
    font-weight: bold;
    font-family: Arial;

}

  .div_informacao_contato {
      position: fixed;
      top: 80%;
      left: 93%;
  }


   @media(max-width: 1290px) {
      .div_informacao_contato {
        position: fixed;
        top: 80%;
        left: 90% !important;
      }
  }

  @media(max-width: 480px) {
      .div_informacao_contato {
        position: fixed;
        top: 80%;
        left: 80% !important;
      }
  }


</style>







// WEBPACK FOOTER //
// src/components/includes/BotaoContato.vue